<div class="nav-header">
  <p>{{ 'SIDEBAR.SPACES' | translate | uppercase }}</p>
</div>

  <div class="nav-list">
    <!-- Overview item -->
    <div class="nav-item-wrapper">
      <div class="nav-item" [class.active]="isOverviewActive" (click)="goToOverview()" (keydown.enter)="goToOverview()" tabindex="0">
        <div class="nav-item-inner">
          <a>{{ 'SIDEBAR.OVERVIEW' | translate }}</a>
        </div>
      </div>
    </div>

    <!-- Space items -->
    @if (spaces$ | async; as spaces) {
      @for (space of spaces; track space) {
        <div class="nav-item-wrapper">
          <!-- Space header -->
          <div class="nav-item space-header" [class.expanded]="isSpaceExpanded(space)" (click)="openSpace(space)" (keydown.enter)="openSpace(space)" tabindex="0">
            <div class="nav-item-inner">
              <a>{{ space.name }}</a>
              <svg class="chevron" [class.expanded]="isSpaceExpanded(space)" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
          <!-- Sub-navigation items (visible when expanded) -->
          @if (isSpaceExpanded(space)) {
            <div class="sub-nav-list">
              @for (item of getNavItems(space); track item.route) {
                <a class="sub-nav-item"
                  [routerLink]="item.route"
                  routerLinkActive="active">
                  <span>{{ item.labelKey | translate }}</span>
                </a>
              }
            </div>
          }
        </div>
      }
    }
  </div>
